/**
 * Contains code to interact with the App Store.
 */

export default class AppStore {
  constructor ({ appId } = {}) {
    this.appId = appId
    this.link = `https://itunes.apple.com/us/app/id${appId}?mt=8`
  }
}
